const common: Record<string, string> = {
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.categories': 'Categories',
  'nav.onboarding': 'Onboarding',
  'nav.countries': 'Countries',
  'nav.updates': 'Updates',
  'nav.contact': 'Contact',
  'nav.getStarted': 'Get Started',
  'nav.menu': 'Menu',
  'lang.switch': 'Language',
};
export default common;
